import { combineReducers, Reducer } from "@reduxjs/toolkit";
import accountReducer from "./accountReducer";
import businessDetailsReducer from "./businessDetailsReducer";
import businessProductsReducer from "./businessProductsReducer";
import cartReducer from "./cartReducer";
import customerInfoReducer from "./customerInfoReducer";
import deliveryInfoReducer from "./deliveryInfoReducer";
import insuranceInfoReducer from "./insuranceInfoReducer";
import memberReducer from "./memberReducer";
import paymentReducer from "./paymentReducer";
import phoneNumbersReducer from "./phoneNumbersReducer";
import reSwitchReducer from "./reSwitchReducer";
import subscriptionsReducer from "./subscriptionsReducer";
import verificationReducer from "./verificationReducer";
import { FORM_ID } from "../../../../../constants";
import { createReducer as createFormsReducer } from "../../../rapidform";

const reducer: Reducer = combineReducers({
    account: accountReducer,
    businessDetails: businessDetailsReducer,
    businessProduct: businessProductsReducer,
    cart: cartReducer,
    customerInfo: customerInfoReducer,
    deliveryInfo: deliveryInfoReducer,
    insuranceInfo: insuranceInfoReducer,
    isMbb: (state = false) => state,
    member: memberReducer,
    offeringPages: (state = {}) => state,
    offerings: (state = {}) => state,
    offeringType: (state = null) => state,
    payment: paymentReducer,
    phoneNumbers: phoneNumbersReducer,
    preSelectedOffering: (state = "") => state,
    reSwitch: reSwitchReducer,
    subscriptions: subscriptionsReducer,
    verification: verificationReducer,
    webdeals: (state = {}) => state,
    [FORM_ID.PERSONAL_DETAILS]: createFormsReducer(FORM_ID.PERSONAL_DETAILS),
    [FORM_ID.BUSINESS_DETAILS]: createFormsReducer(FORM_ID.BUSINESS_DETAILS),
    [FORM_ID.ADD_MEMBER]: createFormsReducer(FORM_ID.ADD_MEMBER),
    [FORM_ID.CONTACT_INFO]: createFormsReducer(FORM_ID.CONTACT_INFO),
    [FORM_ID.EDIT_DELIVERY_ADDRESS]: createFormsReducer(FORM_ID.EDIT_DELIVERY_ADDRESS),
    [FORM_ID.TRANSFER_OWNERSHIP]: createFormsReducer(FORM_ID.TRANSFER_OWNERSHIP),
    [FORM_ID.DSF_MISMATCH]: createFormsReducer(FORM_ID.DSF_MISMATCH),
    [FORM_ID.INCOMPLETE_ORDER]: createFormsReducer(FORM_ID.INCOMPLETE_ORDER),
});

export default reducer;
